import { useContext, useRef } from 'react';
import { isMCQ } from 'chameleon-utility/progressHelpers';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import useListenToRenderedQuestions from 'chameleon/packages/blue-book-player/hooks/useListenToRenderedQuestions';
import {
  setAnswerChoiceLabel,
  removeAriaHiddenFromResponse,
} from '../utility/a11y/responseStructure';
import { getQuestionByReference, setMcqRegionA11y } from '../utils';
import { BluebookContext } from '../state/BluebookContext';
import { addHeightAutoForHeightDiv, addPaddingToColumn } from './utils';

const QuestionLayout = ({ learnosityApp }) => {
  const { state: playerState } = useContext(BluebookContext);
  const playerEl = useGetPlayerEl();
  const loadedQuestions = useRef([]);
  const { isApcDataLoading, questions } = playerState;

  const onQuestionRender = (reference) => {
    const question = getQuestionByReference(reference, questions);
    if (!loadedQuestions.current[question.itemId]) {
      loadedQuestions.current[question.itemId] = true;
      addHeightAutoForHeightDiv(playerEl, reference);
      addPaddingToColumn(playerEl, reference);

      if (isMCQ(question)) {
        setMcqRegionA11y(playerEl);
        setAnswerChoiceLabel(playerEl, question);
        removeAriaHiddenFromResponse(playerEl, question);
      }
    }
  };

  useListenToRenderedQuestions(playerState, learnosityApp, onQuestionRender);

  if (isApcDataLoading) {
    return null;
  }

  return null;
};

export default QuestionLayout;
